import React from 'react';
import { get } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VisitorModel } from 'client/data/models/visitor';
import { INVENTORY_TYPES } from 'client/constants/inventory-types';
import { PUB_STATES } from 'client/constants/pub-states';

const MAKES = [
  'Chrysler',
  'Dodge',
  'Jeep',
  'Ram',
  'FIAT',
  'Alfa Romeo',
  'Buick',
  'Cadillac',
  'Chevrolet',
  'GMC',
  'BMW',
];

export const DISCLAIMER_TYPES = {
  BASIC: 'basic',
  SPECIFIC: 'specific',
};

const AVAILABLE_USPRIVACY = ['1NYN', '1YYN'];

export const withDynamicDisclaimer = WrappedComponent => {
  const ComponentUI = props => {
    const { make, privacy } = props;
    const type = get(props, 'type', get(props, 'customConfig.type'));

    const usprivacy = privacy?.uspString;

    const disclaimerType =
      AVAILABLE_USPRIVACY.includes(usprivacy) &&
      MAKES.includes(make) &&
      [INVENTORY_TYPES.CPO, INVENTORY_TYPES.NEW, PUB_STATES.NEW_USED].includes(type)
        ? DISCLAIMER_TYPES.SPECIFIC
        : DISCLAIMER_TYPES.BASIC;

    return <WrappedComponent {...props} disclaimerType={disclaimerType} />;
  };

  const Component = connectToModel(ComponentUI, {
    privacy: bindToPath('privacy', VisitorModel, null, false),
  });

  Component.displayName = 'withDynamicDisclaimer';

  return Component;
};
